export default "__VITE_ASSET__D$8xcOq4__"